import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";
import _onCopiedFrameLoad from "./_onCopiedFrameLoad";

export default {
	_onCopiedFrameLoad,
	
	_getCopiedInp(val) {
		(val === undefined) && ( val = this.getVal() );
		
		const clones = [];
		
		if( (u_.isString(val) && val) ) {
			val = JSON.parse(val);
			
			if(this.useFrame) {
				// iframeを使用している場合
				const $replace = $("<iframe/>").addClass("replaced-inp wysiwyg-frame").attr({
					"name": `${this.inpType}_${this.paramKey}_copied`,
					"data-theme": this.theme
				})
				.on("load", this._onCopiedFrameLoad.bind(this, val))
				.width( this.get("frame").$self.width() );
				
				clones.push($replace);
				
			} else {
				// iframe不使用の場合
				const $replace = $("<div/>");
				clones.push(
					$("<div/>").addClass(`replaced-inp ${this.boxClass}`).append($replace)
				);
				
				clones.push(
					$("<iframe/>").on("load", e => {	// as div onload
						const quill = new this.Quill($replace.get(0), {
							modules: {
								toolbar: false
							},
							readOnly: true,
							theme: this.theme
						});
						
						quill.setContents(val);
						$(e.target).remove();
					})
				);
			}
		}
		
		return clones;
	}
};
